import { Tooltip } from "react-tippy";
import { formatNumber } from "./essential";
import moment from "moment";
export const tableColumns = (month, currentMonth) => {
  const style = {
    fontFamily: '"Roboto", sans-serif',
    fontSize: 14,
    color: "#FFF !important",
    fontWeight: 600,
    marginTop: 10,
    cursor: "pointer",
  };
  const columns = [
    {
      name: (
        <Tooltip position='bottom' title='Location Name' trigger='mouseenter'>
          <h4 style={style}>Location Name</h4>
        </Tooltip>
      ),
      cell: (data) => (
        <span
          style={{
            color: "#000",
            cursor: "pointer",
          }}
          onClick={() => data.handler(data.id, data.name)}
        >
          {data.name}
        </span>
      ),
    },
    {
      name: (
        <Tooltip position='top' title='Overall target' trigger='mouseenter'>
          <h4 style={style}>Target overall</h4>
        </Tooltip>
      ),
      cell: (row) => row["targetAmount"],
    },
    {
      name: (
        <Tooltip
          position='top'
          title={`${month} Target Amount`}
          trigger='mouseenter'
        >
          <h4 style={style}>{currentMonth} Target Amount</h4>
        </Tooltip>
      ),
      cell: (row) => row["currentTargetAmount"],
    },
    {
      name: (
        <Tooltip
          position='top'
          title='Total collected amount  '
          trigger='mouseenter'
        >
          <h4 style={style}>Total Collected</h4>
        </Tooltip>
      ),
      cell: (row) => row["totalCollectedAmount"],
    },
    {
      name: (
        <Tooltip
          position='top'
          title={`${month} collected Amount`}
          trigger='mouseenter'
        >
          <h4 style={style}>{currentMonth} collected amount</h4>
        </Tooltip>
      ),
      cell: (row) => row["currentCollectedAmount"],
    },
    {
      name: (
        <Tooltip
          position='top'
          title='Target amount in the future'
          trigger='mouseenter'
        >
          <h4 style={style}>Advance Collected Amount</h4>
        </Tooltip>
      ),
      cell: (row) => row["advanceCollectedAmount"],
    },
    {
      name: (
        <Tooltip
          position='top'
          title={`Outstanding amount in ${month}`}
          trigger='mouseenter'
        >
          <h4 style={style}>{currentMonth} Outstanding Amount</h4>
        </Tooltip>
      ),
      cell: (row) => row["outstanding"],
    },
    {
      name: (
        <Tooltip
          position='top'
          title='Outstanding Overall'
          trigger='mouseenter'
        >
          <h4 style={style}>Outstanding Overall</h4>
        </Tooltip>
      ),
      cell: (row) => row["unpaidAmount"],
    },
    {
      name: (
        <Tooltip position='top' title='Number of Houses' trigger='mouseenter'>
          <h4 style={style}>Houses</h4>
        </Tooltip>
      ),
      cell: (row) => row["houses"],
    },
    {
      name: (
        <Tooltip position='top' title='Number of agents' trigger='mouseenter'>
          <h4 style={style}>Agents</h4>
        </Tooltip>
      ),
      cell: (row) => row["agents"],
    },
  ];
  return columns;
};
export const monthlyReportColumns = (month, alldata) => {
  const columns = [
    {
      name: "Location",
      cell: (data) => (
        <span
          style={{
            cursor: "pointer",
          }}
          className='report-link'
          onClick={() => {
            if (alldata.length > 1) {
              data.fetchLocation(data?.id);
              data.handler(data.id, data.location.name);
            }
          }}
        >
          {data.location?.name}
        </span>
      ),
    },
    {
      name: "Target Overall",
      cell: (row) => formatNumber(row["totalTargetAmount"]),
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          Total Target
          <br />
          {month}
        </div>
      ),
      cell: (row) => formatNumber(row["currentTargetAmount"]),
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          Collection
          <br /> ({month})
        </div>
      ),
      cell: (row) => formatNumber(row["totalCollectedAmount"]),
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          Outstanding
          <br />
          {month}
        </div>
      ),
      cell: (row) => formatNumber(row["currentOutstandingAmount"]),
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          Outstanding
          <br />
          Overall
        </div>
      ),
      cell: (row) => formatNumber(row["totalOutstandingAmount"]),
    },
  ];
  return columns;
};
export const collectionColumns = (month, year,allData) => {
  const collectionReportColumns = [
    {
      name: "Location",
      cell: (data) => (
        <span
          style={{
            cursor: "pointer",
          }}
          className='report-link'
          onClick={() => {
            if (allData.length > 1) {
              data.handler(data.id);
              data.fetchLocation(data.id);
            };
          }}
        >
          {data.location}
        </span>
      ),
    },
    {
      name: "Total Collected",
      cell: (row) => row["total_collected_amount"],
    },
    {
      name: `Collected for ${month} ${year}`,
      cell: (row) => row["current_collected_amount"],
    },
  ];
  return collectionReportColumns;
};

export const housesReportColumns = (month, allData) => {
  const columns = [
    {
      name: "Location",
      cell: (data) => (
        <span
          style={{
            cursor: "pointer",
          }}
          className='report-link'
          onClick={() => {
            if (allData.length > 1)
              data.handler(data.id, data.name);
              data.fetchLocation(data.id)
          }}
        >
          {data.location?.name}
        </span>
      ),
    },
    {
      name: "Houses All",
      cell: (row) => row["allHouseCount"],
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          COllection
          <br /> Houses
        </div>
      ),

      cell: (row) => row["collectionHouseCount"],
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          COllection
          <br /> Houses
          <br /> {month}
        </div>
      ),
      cell: (row) => row["currentCollectionHouseCount"],
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          Outstanding
          <br /> Houses All
        </div>
      ),
      cell: (row) => row["allOutstandingHouseCount"],
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          Outstanding
          <br /> Past Months
        </div>
      ),
      cell: (row) => row["pastOutstandingHouseCount"],
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          Outstanding
          <br />
          {month}
        </div>
      ),
      cell: (row) => row["currentOutstandingHouseCount"],
    },
  ];
  return columns;
};

export const activityReportColumns = [
  {
    name: "Location",
    cell: (data) => (
      <span
        style={{
          color: "#000",
          cursor: "pointer",
        }}
        onClick={() => data.handler(data.id,data.location, data.name)}
      >
        {data.location}
      </span>
    ),
  },
  {
    name: "Registered Houses",
    cell: (row) => row["registeredHouses"],
  },
  {
    name: "Activity Houses",
    cell: (row) => row["activityHouses"],
  },
  {
    name: <div className='sc-dQoVA huizgM'>Paid Full Houses</div>,
    cell: (row) => row["paidFullHouses"],
  },
  {
    name: <div className='sc-dQoVA huizgM'>Partial Paid Houses</div>,
    cell: (row) => row["partialPaidHouses"],
  },
  {
    name: <div className='sc-dQoVA huizgM'>Paid Amount</div>,
    cell: (row) => row["paidAmount"],
  },
  {
    name: (
      <div className='sc-dQoVA huizgM'>
        Refused To Pay <br />
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;Houses
      </div>
    ),
    cell: (row) => row["refusedToPayHouses"],
  },
  {
    name: (
      <div className='sc-dQoVA huizgM'>
        Promise To Pay
        <br />
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; Houses
      </div>
    ),
    cell: (row) => row["promiseToPayHouses"],
  },
];


// csv export headers
export const monthlyReportHeaders = (period) => {
  return [
    { label: "Location", key: "location" },
    { label: "Parent location", key: "parentLocation" },
    { label: "Target Overall", key: "totalTargetAmount" },
    { label: `Total target(${period})`, key: "currentTargetAmount" },
    { label: `Collection(${period})`, key: "totalCollectedAmount" },
    {
      label: `Collection ${period} (${period})`,
      key: "currentCollectedAmount",
    },
    { label: `Outstanding ${period}`, key: "currentOutstandingAmount" },
    { label: "Outstanding Overall", key: "totalOutstandingAmount" },
  ];
}
export const paymentHeaders = [
  { label: "Id", key: "id" },
  { label: "Datetime", key: "datetime" },
  { label: "Collection Account", key: "collectionAccount" },
  { label: "Transaction Id", key: "transactionId" },
  { label: "Payer", key: "payer" },
  { label: "Names", key: "accountNames" },
  { label: "Amount", key: "amount" },
  { label: "Province", key: "province" },
  { label: "District", key: "district" },
  { label: "Sector", key: "sector" },
  { label: "Cell", key: "cell" },
  { label: "Village", key: "village" },
  { label: "Info", key: "paymentInfo" },
];
export const accountHeaders = [
  { label: "Id", key: "id" },
  { label: "Type", key: "type" },
  { label: "Names", key: "accountName" },
  { label: "Account Number", key: "accountNumber" },
  { label: "Location", key: "locationName" },
  { label: "Monthly Fee", key: "monthlyFee" },
  { label: "Outstanding", key: "outstandingAmount" },
  { label: "Status", key: "status" },
  { label: "Created On", key: "createdAt" },
];
export const houseHeaders = [
  { label: "Id", key: "id" },
  { label: "Account", key: "accountId" },
  { label: "Location", key: "location" },
  { label: "Category", key: "category" },
  { label: "Status", key: "status" },
  { label: "Monthly Fee", key: "securityFeeAmount" },
  { label: "Created On", key: "createdAt" },
];
export const billHeaders = [
  { label: "Id", key: "id" },
  { label: "Bill Run", key: "bill_run" },
  { label: "Account", key: "account" },
  { label: "House", key: "house" },
  { label: "period", key: "period" },
  { label: "Type", key: "type" },
  { label: "Amount", key: "amount" },
  { label: "Status", key: "status" },
  { label: "Datetime", key: "datetime" },
];
export const collectionReportHeaders = (month, year) => {
  return [
    { label: "Location", key: "location" },
    { label: "Parent location", key: "parentLocation" },
    { label: "Total Collected", key: "total_collected_amount" },
    {
      label: `Collected for ${month} ${year}`,
      key: "current_collected_amount",
    },
  ];
};

export const housesReportHeaders = (period) => {
  return [
    { label: "Location", key: "location" },
    { label: "Houses All", key: "allHouseCount" },
    { label: "Collection Houses", key: "collectionHouseCount" },
    {
      label:`Collection Houses ${period}`,
      key: "currentCollectionHouseCount",
    },
    {
      label: "Outstanding Houses All",
      key: "allOutstandingHouseCount",
    },
    {
      label: "Outstanding Past Monts",
      key: "pastOutstandingHouseCount",
    },
    {
      label: `Outstanding ${period}`,
      key: "currentOutstandingHouseCount",
    },
  ];
} 
export const activityReportHeaders = [
  { label: "Location", key: "location" },
  { label: "Registered Houses", key: "registeredHouses" },
  { label: "Activity Houses", key: "activityHouses" },
  { label: "Paid Full Houses", key: "paidFullHouses" },
  { label: "Paid Amount", key: "paidAmount" },
  { label: "Partial Paid Houses", key: "partialPaidHouses" },
  { label: "Refused To Pay Houses", key: "refusedToPayHouses" },
  {
    label: "Promise To Pay Houses",
    key: "promiseToPayHouses",
  },
];

const styles = { color: "#FFF" };
export const accountColumns = [
  {
    name: <div style={styles}>Id</div>,
    cell: (row) => row["id"],
  },
  { name: <div style={styles}>Type</div>, cell: (row) => row["type"] },
  {
    name: (
      <div style={styles}>
        Account
        <br /> Number
      </div>
    ),
    cell: (row) => row["number"],
  },
  { name: <div style={styles}>Subscriber</div>, cell: (row) => row["owner"] },
  {
    name: <div style={styles}>Location</div>,
    cell: (row) => row["location"],
  },
  {
    name: (
      <div style={styles}>
        Monthly
        <br />
        Fee
      </div>
    ),
    cell: (row) => row["monthly_fee"],
  },
  {
    name: (
      <div style={styles}>
        outst
        <br />
        anding
      </div>
    ),
    cell: (row) => row["outstanding"],
  },
  { name: <div style={styles}>Status</div>, cell: (row) => row["status"] },
  {
    name: (
      <div style={styles}>
        Created
        <br />
        At
      </div>
    ),
    cell: (row) => moment(row["createdAt"]).format("DD-MM-YYYY"),
  },
];
export const houseColumns = [
  {
    name: <div style={styles}>Id</div>,
    cell: (row) => row["id"],
  },
  { name: <div style={styles}>Account<br/>Id</div>, cell: (row) => row["account"] },
  {
    name: (
      <div style={styles}>
        Category
      </div>
    ),
    cell: (row) => row["category"],
  },
  { name: <div style={styles}>Subscriber<br/>Id</div>, cell: (row) => row["owner"] },
  {
    name: <div style={styles}>Monthly Fee</div>,
    cell: (row) => row["monthly_fee"],
  },
  {
    name: (
      <div style={styles}>
        Monthly
        <br />
        Fee
      </div>
    ),
    cell: (row) => row["monthly_fee"],
  },
  { name: <div style={styles}>Status</div>, cell: (row) => row["status"] }
]
export const transferHeaders = [
  { label: "Id", key: "id" },
  { label: "Payee", key: "payee" },
  { label: "Collection Account", key: "collectionAccount" },
  { label: "Payee Number", key: "payeeNumber" },
  { label: "Transaction Id", key: "tid" },
  { label: "Processing Reference Id", key: "prid" },
  { label: "Financial Reference Id", key: "frid" },
  { label: "Amount", key: "amount" },
  { label: "Payment info", key: "info" },
  { label: "Status", key: "status" },
  { label: "Date and time", key: "datetime" },
];

export const dailyTransferReportColumns = [
  {
    name: "Name",
    cell: (row) => row["name"],
  },
  {
    name: "Date",
    cell: (row) => row["date"],
  },
  {
    name: "Total Transfered Amount",
    cell: (row) => row["totalTransferedAmount"],
  },
];

